import { AnimatePresence, motion } from "framer-motion"
import { ComponentProps, PropsWithChildren, useEffect, useRef } from "react"
import { twMerge } from "tailwind-merge"

type Props = PropsWithChildren<ComponentProps<typeof motion.div>> & {
  success?: boolean
  /** Auto-scroll into view when appearing */
  scroll?: boolean
}

export function ErrorMessage({ scroll, ...props }: Props) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scroll && props.children) {
      ref.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [!!props.children, scroll])

  return (
    <AnimatePresence mode="wait">
      {!!props.children && (
        <motion.div
          initial={{ height: 0, opacity: 0, scale: 0.9 }}
          animate={{ height: "auto", opacity: 1, scale: 1 }}
          exit={{ opacity: 0, height: 0, scale: 0.9 }}
          transition={{
            duration: 0.2,
          }}
          ref={ref}
          {...props}
          className={"border-transparent border-t border-b flex flex-col justify-center type-body-m-roman"}
        >
          <div className={twMerge("border py-2 px-3", props.success ? "text-success-dark bg-success-light" : "text-error-dark bg-error-light", props.className)}>
            {props.children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
